import gql from "graphql-tag";

export const getFilters = gql`
  query getFilters {
    areas(first: 100, where: { vacancies_some: {} }) {
      id
      title
    }
    employments(first: 10, where: { vacancies_some: {} }) {
      title
      id
    }
    experiences(first: 10, where: { vacancies_some: {} }) {
      title
      id
    }
    regions(first: 1000, where: { vacancies_some: {} }) {
      id
      title
    }
    schedules(first: 10, where: { vacancies_some: {} }) {
      id
      title
    }
    vacancies(first: 1000) {
      id
      title
    }
  }
`;
